






























































































































































































































































































































































































































































































































































import {
  ComponentInternalInstance,
  defineComponent,
  getCurrentInstance,
  onUnmounted,
  ref,
  toRefs,
  computed,
  onMounted,
  reactive,
  watch,
  nextTick,
} from '@vue/composition-api';
import {
  DownloadIcon,
  ShareIcon,
  EllipsisIcon,
  FolderIcon,
  SearchIcon,
  StarIcon,
  StarFilledIcon,
  CloseCircleFilledIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';
import { Route } from 'vue-router';
import { DirectiveBinding } from 'vue/types/options.d';
import FileIcon from '@/renderer/components/Base/BaseTableFileIcon/FileIcon.vue';

// 引入组件
import renameFolderDialog from '@/renderer/components/dialog/rename.vue';
import selectTargetFolder from '@/renderer/components/dialog/selectTargetFolder/index.vue';
import conflictDialog from '@/renderer/components/dialog/conflict.vue';
import errListDialog from '@/renderer/components/dialog/errList.vue';
import AddFileAuth from '@/renderer/components/dialog/AddTransfer/AddFileAuth/index.vue';
import linkShare from '@/renderer/components/dialog/linkShare/index.vue';
import WemeetLinkShare from '@/renderer/components/dialog/linkShare/WemeetShare.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import searchHistory from '@/renderer/components/searchInput/searchHistory.vue';
import searchConditionSelect from '@/renderer/views/desktop/FileManagement/Search/components/searchConditionSelect.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import detailHandler from '@/renderer/components/SpacePage/compositions/detailHandler';
import searchHandler, { SearchItem } from '@/renderer/views/desktop/FileManagement/Search/composition/searchHandler';
import externalSearchHandler from '@/renderer/scripts/composition/searchHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import deleteHandler from '@/renderer/components/SpacePage/compositions/deleteHandler';
import renameHandler from '@/renderer/components/SpacePage/compositions/renameHandler';
import moveHandler from '@/renderer/components/SpacePage/compositions/moveHandler';
import copyHandler from '@/renderer/components/SpacePage/compositions/copyHandler';
import authHandler from '@/renderer/components/SpacePage/compositions/authHandler';
import linkShareHandler from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import extraFileInfoHandler from '@/renderer/components/SpacePage/compositions/extraFileInfoHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import shareInWeMeetingHandler from '@/renderer/views/desktop/headbar/composition/shareInWeMeetingHandler';
import { drawerHandler } from '@/renderer/scripts/composition/drawerHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import { historyHandler } from '@/renderer/components/searchInput/compositions/historySearchHandler';
import { actionHandler } from '@/renderer/components/SpacePage/compositions/actionHandler';
import guideHandle from '@/renderer/views/desktop/FileManagement/Workbench/composition/guideHandler';

// 引入工具类
import { startGuideSteps } from '@/renderer/scripts/utils/GuideHelper';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import { can, optAuth } from '@/renderer/scripts/composition/authHandler';
import { isNodeOverflow } from '@/renderer/scripts/utils/tools/index';
import {
  noPreview,
  isAllowPreviewImage,
  isAllowPrivate,
  isAllowEditDoc,
} from '@/renderer/scripts/composition/allowPreview';
import { renderFileNameEle, renderFileContentEle } from '@/renderer/scripts/composition/renderFileEle';
import ipc from '@/renderer/scripts/utils/ipc';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import tips from '@/renderer/scripts/utils/tips';
import { SMH } from '@/renderer/scripts/smh';
import store from '@/renderer/store';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { openFolderOrDirectory } from '@/renderer/scripts/utils/openFolderOrDirectory';
export default defineComponent({
  // 路由守卫判断：避免直接出现跳转到搜索,但是没有上一个搜索路由信息场景
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    const searchPreviousName = store.getters.searchPreviousRoute.name;
    if (!searchPreviousName) {
      const { name, query, params } = from;
      const newQuery = query?.fromRoute ? _.omit(query, 'fromRoute') : query;
      const scope = from.query?.path ? 'current' : 'all';
      store.commit('SET_SEARCH_PREVIOUSROUTE', {
        name,
        query: newQuery,
        params,
      });
      store.commit('SET_SEARCH_SCOPE', scope);
    }
    next();
  },
  beforeRouteLeave(to: Route, from: Route, next: Function) {
    // 退出搜索：重置keyword为''
    ipc.emit(ipc.RENDERER_EVENTS_MAP.RESET_SEARCH);
    // 头部header发起电子签、文件收集从搜索进入下一级目录以及pc端预览不清空搜索路由信息
    if (
      !['electronicSign', 'fileCollect'].includes(to.name as string) &&
      !to.path.includes('/web/preview/') &&
      to.query?.fromRoute !== 'search'
    ) {
      // 退出搜索后：清空信息上一个搜索路由信息
      store.commit('SET_SEARCH_PREVIOUSROUTE', {
        name: '',
      });
      store.commit('SET_SEARCH_SCOPE', 'all');
      store.commit('SET_SEARCH_KEYWORD', '');
    }
    next();
  },
  components: {
    FileIcon,
    StatusTag,
    renameFolderDialog,
    selectTargetFolder,
    conflictDialog,
    errListDialog,
    AddFileAuth,
    linkShare,
    WemeetLinkShare,
    DownloadIcon,
    ShareIcon,
    EllipsisIcon,
    FolderIcon,
    SearchIcon,
    StarIcon,
    StarFilledIcon,
    CloseCircleFilledIcon,
    Menu,
    MenuItem,
    SelectAnySpaceTargetFolder,
    searchHistory,
    searchConditionSelect,
  },
  directives: {
    renderEllipsis: {
      bind(el: HTMLElement, binding: DirectiveBinding) {
        setTimeout(() => {
          const isCutOff = isNodeOverflow(el);
          binding.value.isCutOff = isCutOff;
        }, 0);
      },
    },
  },
  filters: {
    SearchTab(tabValue: 'all' | 'dir' | 'file' | 'image' | 'media', list: SearchItem[]) {
      const map = {
        all: i18n_t('全部'),
        dir: i18n_t('文件夹'),
        file: i18n_t('文档'),
        image: i18n_t('图片'),
        media: i18n_t('音视频'),
      };
      return `${map[tabValue]} (${list.length})`;
    },
  },
  setup(props, context) {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const searchPreviousRoute = computed(() => store.getters.searchPreviousRoute);
    const routeName = computed(() => searchPreviousRoute.value.name);
    const tmpspaceId = ref((searchPreviousRoute.value.query?.spaceId as string) || '');
    const spaceId = computed({
      get() {
        return tmpspaceId.value;
      },
      set(val: string) {
        tmpspaceId.value = val as string;
      },
    });
    const originPathText = computed(() => {
      let pathText = '';
      if (searchPreviousRoute.value.query?.path) {
        const pathArray = searchPreviousRoute.value.query?.path.split('/');
        pathText = pathArray[pathArray.length - 1];
      } else if (searchPreviousRoute.value.query?.teamPath) {
        const pathArray = searchPreviousRoute.value.query?.teamPath.split('/');
        pathText = pathArray[pathArray.length - 1];
      } else if (searchPreviousRoute.value.query?.name) {
        pathText = searchPreviousRoute.value.query?.name;
      } else if (routeName.value === 'personalSpace') {
        pathText = i18n_t('个人空间');
      } else {
        pathText = i18n_t('我的工作台');
      }
      return pathText;
    });
    const isGlobalSearch = computed(() => {
      if (store.getters.isMobileStyle) {
        return store.getters.searchScope === 'global';
      }
      return store.getters.searchScope === 'global' && routeName.value === 'workbench';
    });
    const originRouteName = ref(searchPreviousRoute.value.name);
    // 文件夹选择组件下拉列表控制
    const selectOptions = computed(() => {
      const { userBaseInfo } = store.getters;
      const { isTemporary } = userBaseInfo;
      if (isTemporary) {
        return ['group'];
      }
      return [];
    });

    // 要操作的对象
    const selectItem = ref({});
    const canCopyMove = ref(routeName.value !== 'relatedToMeFileList');
    const showHistoryTab = ref(false);
    const firstEnterTag = ref(true); // 首次进入搜索页标记
    const firstFocusTag = ref(true);
    const currentSpace = ref('');
    const currentFolder = ref('');
    const scopePopupVisible = ref(false);
    const showSearchTooltip = ref(false);
    /**
     * T-design 等宽不能根据窗口大小变化而变化
     * inputWidth 添加该字段进行等宽处理
     */
    const inputWidth = ref(0);
    const inputBox = ref();

    // table表格宽度计算
    const tableWidth = ref(0);
    const { methods: externalSearchMethods } = externalSearchHandler();
    const { methods: gudieMethods } = guideHandle();
    const {
      searchParams,
      searchCondition,
      SearchRangeOptions,
      SearchTypeOptions,
      SearchTimeOptions,
      SearchSizeOptions,
      SearchMemberOptions,
      columns,
      loading: loadingList,
      loadingStatus,
      isAccurateSearch,
      methods: searchMethods,
      tableData,
      sort,
    } = searchHandler(spaceId);
    const { filterMethods } = actionHandler();
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      isDropdownShow,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const { show: showDetail, methods: detailMethods } = detailHandler(spaceId);
    const { methods: downloadMethods } = downloadHandler(spaceId);
    const { methods: deleteMethods } = deleteHandler(spaceId);
    const {
      show: showRename,
      originName: fromName,
      type: renameType,
      methods: renameMethods,
      renameError,
    } = renameHandler(spaceId);
    const { show: showMoveTarget, methods: moveMethods } = moveHandler(spaceId);
    const { show: showCopyTarget, methods: copyMethods } = copyHandler(spaceId);
    const { show: showAuth, authParams, methods: authMethods } = authHandler(spaceId);
    const { show: showLink, showWemeetShare, linkData, methods: linkShareMethods } = linkShareHandler(spaceId);
    const { methods: extraFileInfoMethods } = extraFileInfoHandler(spaceId);
    const { methods: previewMethods } = openPreviewHandler(spaceId);
    const { methods: wemeetingMethods } = shareInWeMeetingHandler();
    const { drawerHandlerMethods } = drawerHandler();
    const { historyStore, methods: historyMethods } = historyHandler();
    const show = reactive({
      history: false,
      searchPath: false,
    });

    const methods = {
      showGuide() {
        const { searchGuideFinished } = vm.$store.getters.noviceGuidance;
        const { enableGlobalFullTextSearch } = vm.$store.getters;
        if (!searchGuideFinished && enableGlobalFullTextSearch) {
          nextTick(() => {
            const searchGuide = [
              {
                title: i18n_t('支持全文搜索'),
                context: i18n_t('可指定文件名或全文内容检索，文档内容的快速定位，轻松检索核心数据。'),
                id: 'search-guide',
                type: 'search',
                className: 'top-more',
                position: 'bottom',
              },
            ];

            startGuideSteps(searchGuide, true);
            gudieMethods.goSearchGuide();
            // 4s后弹窗消失
            setTimeout(() => {
              ipc.emit(ipc.RENDERER_EVENTS_MAP.STOP_SEARCH_GUIDE);
            }, 4000);
          });
        }
      },
      initData() {
        const {
          searchKeyWord: keyword,
          searchScope: scope,
          searchCondition: innerSearchCondition,
          isInitConditionData,
        } = store.getters;
        searchParams.keyword = vm.$route.query?.keyword || keyword.trim();
        searchParams.scope = scope;
        // 回退搜索时需要
        if (isInitConditionData) {
          searchParams.range = innerSearchCondition.range;
          searchParams.types = innerSearchCondition.types;
          searchParams.time = innerSearchCondition.times;
          searchParams.size = innerSearchCondition.size;
          searchParams.member = innerSearchCondition.member;
          Object.assign(searchCondition, innerSearchCondition.extraData);
          store.commit('SET_INIT_CONDITION_DATA', false);
          methods.onSearch();
        } else {
          searchParams.keyword && methods.onSearch();
        }
      },
      async onOperateEventProxy(command: string, item: SMH.SearchFileData, btnLocation?: string) {
        spaceId.value = item?.spaceId ?? spaceId.value;
        switch (command) {
          case 'open':
            if (item.type === 'dir') {
              // 进入文件夹后重置当前页为默认值;
              methods.jumpToDir(item, 'openFolder');
            } else if (noPreview(item)) {
              tips.error(i18n_t('该格式暂不支持预览'));
            } else if (!item.authorityList?.canPreview) {
              tips.error(i18n_t('暂无预览权限，请联系管理员'));
            } else if (isAllowPreviewImage(item.name) && +item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              previewMethods.openPreview(item, 1);
            }
            break;
          case 'delete':
            deleteMethods.confirmDelete([item], false);
            break;
          case 'download':
            downloadMethods.prepareDownload([item]);
            break;
          case 'rename':
            renameMethods.openRenameFolder(item);
            break;
          case 'detail':
          case 'history': {
            selectItem.value = item;
            const detailScope: Drawer.DetailScope<SMH.SpaceFileItemData> = {
              title: i18n_t('详细信息'),
              componentName: 'Detail',
              // 个人版本的spaceId会自动传递
              params: {
                selectedItem: item,
                spaceId: spaceId.value,
              },
            };
            const historyScope: Drawer.HistoryScope<SMH.SpaceFileItemData> = {
              title: i18n_t('历史版本'),
              componentName: 'History',
              // 个人版本的spaceId 传递为空字符
              params: {
                selectedItem: item,
                spaceId: spaceId.value,
              },
            };
            drawerHandlerMethods.setDrawers([detailScope, historyScope]);
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_SHOW_DETAIL, command);
            break;
          }
          case 'move':
            moveMethods.openSelectFolder([item]);
            break;
          case 'copy':
            copyMethods.openSelectFolder([item]);
            break;
          case 'auth':
            {
              if (checkIfMobileStyle()) return;
              const _teamId = vm.$route.query?.teamId;
              const teamId = _teamId ? +_teamId : undefined;
              const params = {
                userId: +item.userId,
                virusAuditStatus: item.virusAuditStatus,
                path: item.path.join('/'),
                spaceTag: item.spaceTag as string,
                teamId,
              };
              const canOpenAuthDialog = authMethods.canOpenAuthDir(params);
              if (!canOpenAuthDialog) return;
              Object.assign(authParams, { params });
              showAuth.value = true;
            }
            break;
          case 'share': {
            const formatItem: SMH.SpaceFileItemData = _.cloneDeep(item);
            const shareData = [formatItem];
            if (store.getters.isInWeMeetApp) {
              const { preview, edit } = methods.getFileOrDirPermission(item);
              shareData[0] = {
                ...formatItem,
                canPreview: preview,
                canEdit: edit,
              };
            }
            linkShareMethods.openShare(shareData);
            break;
          }
          case 'addFavorite':
            extraFileInfoMethods.addFavorite(item, tableData.list);
            break;
          case 'delFavorite':
            extraFileInfoMethods.delFavorite([item.favoriteId], tableData.list);
            break;
          case 'edit':
            if (!item.authorityList?.canModify) {
              tips.error(i18n_t('暂无权限，请联系管理员'));
            } else {
              await previewMethods.openEdit(item);
            }
            break;
          case 'preview':
            if (isAllowPreviewImage(item.name) && +item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              previewMethods.openPreview(item, 1);
            }
            break;
          case 'openOriginDirectroy':
            methods.jumpToDir(item, 'openOriginDirectroy');
            break;
          case 'invite_to_preview':
          case 'invite_to_edit': {
            const [, , action] = command.split('_');
            wemeetingMethods.share(action, {
              ...item,
              spaceId: spaceId.value,
              btnLocation,
            });
            break;
          }
          case 'esign': {
            previewMethods.openPreview(item, 1, {
              esign: true,
            });
            break;
          }
          default:
            break;
        }
      },
      jumpToDir(item: SMH.SearchFileData, action = 'openFolder') {
        store.commit('SET_SEARCH_KEYWORD', searchParams.keyword); // 存取本次搜索关键字，便于回退到搜索
        store.commit('SET_SEARCH_CONDITION', {
          range: searchParams.range,
          types: searchParams.types,
          times: searchParams.time,
          size: searchParams.size,
          member: searchParams.member,
          extraData: searchCondition,
        });
        if (action === 'openFolder') {
          // 打开文件夹
          openFolderOrDirectory({ item, isOpenFolder: true, targetRouteName: '', currentRouteName: 'search' });
        } else if (action === 'openOriginDirectroy') {
          // 打开源目录
          openFolderOrDirectory({ item, isOpenFolder: false, targetRouteName: '', currentRouteName: 'search' });
        }
      },
      renderEllipsisPopup() {
        const [ele] = document.getElementsByClassName('filename');
        if (ele) {
          const { left } = ele.getBoundingClientRect();
          return {
            left: `${left}px`,
          };
        }
        return {};
      },
      refreshList(
        data: SearchItem[] & {
          originPathStr: string[];
          path: string[];
        },
        action?: string,
      ) {
        if (data && action === 'delete') {
          const [item] = data;
          const index = tableData.list.findIndex(searchItem => _.isEqual(searchItem, item));
          tableData.list.splice(index, 1);
        } else if (action === 'rename' && data.originPathStr) {
          // 重命名则改列表缓存
          const index = tableData.list.findIndex(searchItem => _.isEqual(searchItem.path, data.originPathStr));
          // 移除同名文件
          const sameNameIndex = tableData.list.findIndex(searchItem => _.isEqual(searchItem.path, data.path));
          sameNameIndex > -1 && tableData.list.splice(sameNameIndex, 1);
          const newItem = {
            ...tableData.list[index],
            name: data.path[data.path.length - 1],
            path: data.path,
            highlight: null,
          };
          vm.$set(tableData.list, index, newItem);
        } else {
          searchMethods.onSearch();
        }
      },
      onInputchange() {
        if (!searchParams.keyword) {
          if (firstFocusTag.value) {
            // 首次自动focus需异步，避免获取不到实际宽度
            setTimeout(() => {
              methods.computeInputWidth();
              show.history = true;
            }, 300);
          } else {
            methods.computeInputWidth();
            show.history = true;
          }
        } else {
          show.history = false;
        }
        firstFocusTag.value = false;
      },
      scopePopupChange(visible: boolean) {
        setTimeout(() => {
          show.history = false;
        }, 0);
        scopePopupVisible.value = visible;
      },
      showCustomizeScope() {
        scopePopupVisible.value = false;
        show.searchPath = true;
      },
      selectOtherPath(params: {
        spaceId: string;
        spaceOrgId: string;
        teamId: string;
        groupId: string;
        teamPath: string;
        totalPath: string;
        dirPath: string;
        fromSpace: string;
      }) {
        spaceId.value = params.spaceId;
        show.searchPath = false;
        const otherPathScope = params.dirPath ? 'current' : 'all';
        let otherPathRouteName = 'personalSpace';
        let otherPathRouteQuery = {};
        if (params.fromSpace === 'personal') {
          otherPathRouteName = 'personalSpace';
          otherPathRouteQuery = {
            path: params.dirPath,
          };
        } else if (params.fromSpace === 'team') {
          otherPathRouteName = 'teamSpace';
          otherPathRouteQuery = {
            teamPath: params.teamPath,
            path: params.dirPath,
            spaceId: params.spaceId,
            teamId: params.teamId,
          };
        } else if (params.fromSpace === 'group') {
          otherPathRouteName = 'collaborationSpaceList';
          otherPathRouteQuery = {
            path: params.dirPath,
            id: params.groupId,
            spaceId: params.spaceId,
            spaceOrgId: params.spaceOrgId,
            name: params.totalPath.split('/')[1],
          };
        }
        store.commit('SET_SEARCH_PREVIOUSROUTE', {
          name: otherPathRouteName,
          query: otherPathRouteQuery,
        });
        store.commit('SET_SEARCH_SCOPE', otherPathScope);
        store.commit('SET_SEARCH_KEYWORD', searchParams.keyword);
      },
      onHistoryClickOutside() {
        show.history = false;
      },
      onSearch(isVagueSearch?: boolean | object) {
        isAccurateSearch.value = typeof isVagueSearch === 'boolean' ? !isVagueSearch : true;
        show.history = false;
        searchParams.keyword = searchParams.keyword.trim();
        if (firstEnterTag.value && !searchParams.keyword) {
          searchMethods.pullList();
        } else {
          searchParams.keyword && historyMethods.setHistory(searchParams.keyword);
          store.commit('SET_SEARCH_KEYWORD', searchParams.keyword);
          dispatchRouter(
            {
              query: {
                keyword: searchParams.keyword,
              },
            },
            'replace',
          );

          searchMethods.onSearch();
        }
        firstEnterTag.value = false; // 进行一次搜索则去除标记

        // 上报搜索信息
        reporter.report('search', {
          search_catalog: searchParams.scope,
          search_location: originRouteName.value,
          // 进入搜索的空间位置
          search_for_location: routeName.value,
          // 正在搜索的空间位置
          search_content: searchParams.range,
          search_type: searchParams.types,
          search_time: searchParams.time,
          search_size: searchParams.size,
          search_updater: searchParams.members,
        });
      },
      // 精准搜索无结果时，进行模糊搜索
      onVagueSearch() {
        methods.onSearch(true);
      },
      clearSearchKeyword() {
        searchParams.keyword = '';
        methods.onSearch();
      },
      onReturn() {
        externalSearchMethods.exitSearch();
      },
      getFileOrDirPermission(item: SMH.SearchFileData): Record<string, boolean> {
        const { isMobileStyle, isMobile, isInWeMeetApp, editionFlag, enableShare, isPrivate } = store.getters;
        const canShare = can('Share', item) && enableShare;
        const canPreview = item.type !== 'dir' && optAuth('Preview', item);
        const canEdit = item.type !== 'dir' && optAuth('Edit', item);
        let actionMap: Record<string, boolean> = {
          share: canShare,
          addFavorite: canCopyMove.value && !item.favorited,
          delFavorite: canCopyMove.value && item.favorited,
          rename: true,
          // FIX：搜索这里的重命名按钮放开，靠后台来决定是否有无重命名（前端判断会误伤实际有重命名权限的情况）
          // move: canCopyMove.value && can('Delete', item) && can('Download', item),
          // copy: canCopyMove.value && can('Download', item),
          auth: editionFlag === 'enterprise' && can('Authorize', item),
          delete: can('Delete', item),
          preview: canPreview,
          edit: canEdit,
          esign: vm.$route.name === 'teamSpace' && optAuth('Esign', item) && !isPrivate,
          // 非移动端界面不给 详情、历史版本、下载入口
          // 移动端腾讯会议不给下载入口
          download: optAuth('Download', item) && ((!isInWeMeetApp && isMobileStyle) || (isInWeMeetApp && !isMobile)),
          detail: isMobileStyle && can('View', item),
          history: isMobileStyle && item.type !== 'dir',
          // 腾讯会议中才展示
          invite_to_preview: isInWeMeetApp && canShare && canPreview,
          invite_to_edit: isInWeMeetApp && canShare && canEdit,
        };
        actionMap = filterMethods.filterAll(actionMap, item);
        return actionMap;
      },
      /**
       * 计算表格中更多下拉菜单子项是否渲染
       */
      renderDropdownItemOptions(item: SMH.SearchFileData) {
        const map: Record<string, string> = {
          // 腾讯会议中此2入口放最上
          invite_to_preview: i18n_t('邀请预览'),
          invite_to_edit: i18n_t('邀请编辑'),
          detail: i18n_t('详情'),
          download: i18n_t('下载'),
          preview: i18n_t('在线预览'),
          edit: i18n_t('在线编辑'),
          esign: i18n_t('发起电子签'),
          // TODO: 和产品确认，由于目前复制和移动不能跨空间，搜索先隐藏这两功能
          // move: '移动到',
          // copy: '复制到',
          rename: i18n_t('重命名'),
          addFavorite: i18n_t('收藏'),
          delFavorite: i18n_t('取消收藏'),
          auth: i18n_t('添加共享成员'),
          history: i18n_t('历史版本'),
          delete: i18n_t('删除'),
        };
        const allow: Record<string, boolean> = methods.getFileOrDirPermission(item);
        const options: Array<{
          content: string;
          value: string;
        }> = [];
        Object.keys(map).forEach(key => {
          if (allow[key]) {
            options.push({
              content: map[key],
              value: key,
            });
          }
        });
        return options;
      },
      // 添加选中态类
      renderRowClass(params: any) {
        return tableData.selectedRowKeys.join(',') === params?.row.id ? 'is-selected' : '';
      },
      // 计算搜索历史popup的宽度
      computeInputWidth() {
        inputWidth.value = inputBox.value.$el.offsetWidth;
      },
      // 计算表格宽度
      computeTableWidth() {
        tableWidth.value = document.getElementById('rootDomForDrawer')?.offsetWidth || 0;
      },
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, methods.refreshList);
    ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_SEARCH, methods.onSearch);
    methods.initData();
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        methods.onReturn();
      }
    };
    onMounted(() => {
      methods.showGuide();
      store.commit(DrawerEvents.DESTORY_DRAWER);
      document.addEventListener('keyup', handleEscKey);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, methods.refreshList);
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_SEARCH, methods.onSearch);
      document.removeEventListener('keyup', handleEscKey);
    });

    // 监听路由信息变化
    watch(
      () => store.getters.searchPreviousRoute,
      val => {
        currentFolder.value = val.query?.path ? val.query?.path : '';
        searchParams.scope = store.getters.searchScope;
        if (routeName.value === 'collaborationSpaceList') {
          currentSpace.value = val.query?.name as string;
        } else if (routeName.value === 'teamSpace') {
          const newTeamPath = val.query?.teamPath as string;
          currentSpace.value = newTeamPath ? (newTeamPath.split('/').pop() as string) : '';
        }
      },
      {
        immediate: true,
      },
    );

    watch(
      () => show.history,
      val => {
        val && historyMethods.getHistory();
      },
    );

    watch(loadingList, val => {
      !val && methods.computeTableWidth();
    });
    window.onresize = (e: Event) => {
      methods.computeInputWidth();
      methods.computeTableWidth();
    };
    return {
      spaceId,
      originPathText,
      firstEnterTag,
      tableWidth,
      inputWidth,
      inputBox,
      columns,
      loadingList,
      loadingStatus,
      isAccurateSearch,
      searchMethods,
      ...toRefs(tableData),
      sort,
      show,
      routeName,
      currentSpace,
      currentFolder,
      isGlobalSearch,
      searchParams,
      searchCondition,
      SearchRangeOptions,
      SearchTypeOptions,
      SearchTimeOptions,
      SearchSizeOptions,
      SearchMemberOptions,
      scopePopupVisible,
      showSearchTooltip,
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      isDropdownShow,
      listOperateMethods,
      historyStore,
      historyMethods,
      ...methods,
      showDetail,
      showHistoryTab,
      selectItem,
      showRename,
      fromName,
      renameType,
      renameError,
      renameMethods,
      showMoveTarget,
      moveMethods,
      showCopyTarget,
      copyMethods,
      showAuth,
      authParams,
      authMethods,
      can,
      optAuth,
      canCopyMove,
      showLink,
      showWemeetShare,
      linkData,
      selectOptions,
      renderFileNameEle,
      renderFileContentEle,
    };
  },
});
